/**************************************************
 * Nombre:       Formulario_Producto_Imagenes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoImagenCropLista from "../../Modulo_formularios/Componentes/IngresoImagenCropLista";


const Formulario_Producto_Imagenes = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagenes o fotos adicionales de la prenda</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCropLista alto={6} ancho={4}
                        dato={'imgs'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Imagenes